"use client";

import { useState } from "react";
import posthog from "posthog-js";

type State = "idle" | "submitting" | "success" | "error";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<State>("idle");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrorMessage("Please enter a valid email address.");
      setState("error");
      return;
    }

    setState("submitting");
    setErrorMessage("");

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const json = await res.json();
      if (!res.ok) {
        setErrorMessage(json.error ?? "Something went wrong.");
        setState("error");
      } else {
        posthog.identify(email, { email });
        posthog.capture("newsletter_subscribed", { email });
        setState("success");
        setEmail("");
      }
    } catch {
      setErrorMessage("Network error. Please try again.");
      setState("error");
    }
  }

  if (state === "success") {
    return (
      <p className="text-green-400 text-sm font-medium">
        You&apos;re in. Thanks for subscribing!
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        required
        className="flex-1 px-4 py-2.5 bg-white/10 border border-white/20 text-white placeholder-gray-500 text-sm outline-none focus:border-brand-orange transition-colors"
      />
      <button
        type="submit"
        disabled={state === "submitting"}
        className="px-6 py-2.5 bg-brand-orange-dark text-white text-[11px] font-bold uppercase tracking-[0.2em] hover:bg-brand-orange transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {state === "submitting" ? "Subscribing…" : "Subscribe"}
      </button>
      {state === "error" && errorMessage && (
        <p className="text-red-400 text-xs mt-1 sm:col-span-2">{errorMessage}</p>
      )}
    </form>
  );
}
